import { render, staticRenderFns } from "./preparar-certificado.vue?vue&type=template&id=2585f652&"
import script from "./preparar-certificado.vue?vue&type=script&lang=js&"
export * from "./preparar-certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports